var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterInstagramBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_3028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3126 12.3162C13.1003 12.3162 11.2672 14.1176 11.2672 16.3616C11.2672 18.6055 13.0687 20.407 15.3126 20.407C17.5566 20.407 19.3581 18.5739 19.3581 16.3616C19.3581 14.1492 17.525 12.3162 15.3126 12.3162ZM15.3126 18.9532C13.8904 18.9532 12.721 17.7838 12.721 16.3616C12.721 14.9394 13.8904 13.77 15.3126 13.77C16.7349 13.77 17.9042 14.9394 17.9042 16.3616C17.9042 17.7838 16.7349 18.9532 15.3126 18.9532Z",
    fill: "#F25C05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5162 13.1383C20.0223 13.1383 20.4327 12.7279 20.4327 12.2217C20.4327 11.7155 20.0223 11.3052 19.5162 11.3052C19.01 11.3052 18.5996 11.7155 18.5996 12.2217C18.5996 12.7279 19.01 13.1383 19.5162 13.1383Z",
    fill: "#F25C05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8865 9.85098C21.0647 8.99764 19.8953 8.55518 18.5679 8.55518H12.0573C9.3077 8.55518 7.47461 10.3883 7.47461 13.1379V19.6169C7.47461 20.9759 7.91708 22.1453 8.80202 22.9986C9.65535 23.8204 10.7931 24.2312 12.0889 24.2312H18.5363C19.8953 24.2312 21.0331 23.7888 21.8549 22.9986C22.7082 22.1769 23.1507 21.0075 23.1507 19.6485V13.1379C23.1507 11.8105 22.7082 10.6727 21.8865 9.85098ZM21.76 19.6485C21.76 20.6283 21.4124 21.4184 20.8435 21.9557C20.2746 22.493 19.4845 22.7774 18.5363 22.7774H12.0889C11.1408 22.7774 10.3507 22.493 9.78177 21.9557C9.21288 21.3868 8.92844 20.5967 8.92844 19.6169V13.1379C8.92844 12.1897 9.21288 11.3996 9.78177 10.8307C10.3191 10.2934 11.1408 10.009 12.0889 10.009H18.5995C19.5477 10.009 20.3378 10.2934 20.9067 10.8623C21.444 11.4312 21.76 12.2213 21.76 13.1379V19.6485Z",
    fill: "#F25C05"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5729 31.796C6.91037 31.8397 -0.195879 24.6397 0.00412094 15.8522C0.191621 7.47724 7.13537 0.53974 15.7791 0.63974C24.3166 0.73974 31.3666 7.85224 31.1416 16.6397C30.9291 24.9772 24.0541 31.8335 15.5729 31.796ZM1.89787 16.2335C1.96662 24.0647 8.29787 30.0835 15.7854 29.971C23.0479 29.8585 29.2354 23.946 29.2416 16.221C29.2416 8.39599 22.8604 2.34599 15.3541 2.47099C8.07912 2.58974 1.94787 8.51474 1.89787 16.2335Z",
    fill: "#F25C05"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_3028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.92,
    height: 17.92,
    fill: "white",
    transform: "translate(6.40002 7.03882)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagramBrands);
export default __webpack_public_path__ + "static/media/footer-instagram-brands.7a91412c8eee40eba0e1b73606dffe08.svg";
export { ForwardRef as ReactComponent };